import { Text } from '@agro-club/agroclub-shared'
import { Contact } from 'modules/domain/user/types'
import { FC, useMemo } from 'react'
import styled from 'styled-components'
import APhone from 'views/ui/Phone/APhone'
import { UserLink } from 'views/components/UserLink/UserLink'
import { useTranslation } from 'react-i18next'

const ContactWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`
const UserWrapper = styled(ContactWrapper)`
  min-height: 42px; //make user height same as contact
`

type Props = {
  contact: Contact
}
export const CompanyContact: FC<Props> = ({ contact }) => {
  const { t } = useTranslation('company')
  const user = useMemo(() => {
    if (contact.contact_id) {
      return null
    } else {
      return { id: contact.user_id.toString(), phone: contact.phone, full_name: contact.fullname }
    }
  }, [contact])

  if (user) {
    return (
      <UserWrapper>
        <div>
          <Text color="secondary" typography="bodyMedium">
            {t('common:user')}
          </Text>
          <UserLink user={user} />
        </div>
        <APhone phone={user.phone} />
      </UserWrapper>
    )
  } else {
    return (
      <ContactWrapper>
        <div>
          <Text color="secondary" typography="bodyMedium">
            {t('extraContact')}
          </Text>
          <div>{contact.fullname}</div>
          {contact.position && (
            <Text color="secondary" typography="bodyMedium">
              {contact.position}
            </Text>
          )}
        </div>
        <APhone phone={contact.phone} />
      </ContactWrapper>
    )
  }
}
